const QRCode = require("qrcode");

/**
 * QR no formato da Lambda (handler.generateqrCode):
 * PNG data URL, URL https://mgs.cards/pr/{serial}.
 * A rotação 180° (verso dobrado) é aplicada no LabelTagPdf via transform.
 */
async function generateQrDataUrl(serial) {
  return QRCode.toDataURL(`https://mgs.cards/pr/${serial}`, {
    margin: 2,
    width: 124,
    errorCorrectionLevel: "M",
  });
}

export { generateQrDataUrl };
